import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
export const MEDAL_SIZES = {
    small: 16,
    medium: 24,
    large: 32
};
const IMAGE_CSS = css `
  filter: drop-shadow(2px 2px 0 rgba(0, 0, 0, 0.15));
`;
export const MedalImageDisplay = ({ size = 'large', medalName, imageUrl }) => {
    const medalSizePx = MEDAL_SIZES[size];
    return _jsx("img", { src: imageUrl, css: IMAGE_CSS, width: medalSizePx, height: medalSizePx, title: `${medalName} Medal` });
};
